// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const mahaRevisionData = createApi({
  reducerPath: "mahaRevisionApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getSubjectByClass: builder.query({
      query: (class_id) => ({
        url: `free_resource_subject`,
        params: {
          class_id,
        },
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    getRevisionBatches: builder.query({
      query: (class_id) => ({
        url: `revision_batch`,
        params: {
          class_id,
        },
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    getMahaRevision: builder.query({
      query: ({ revision_id, class_id }) => ({
        url: `revision_playlist`,
        params: {
          revision_id,
          class_id,
        },
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSubjectByClassQuery,
  useGetRevisionBatchesQuery,
  useGetMahaRevisionQuery,
} = mahaRevisionData;
